import React from "react";

const Portfolio = () => {
  return (
    <section id="portfolio" >
      <div className="a2">
        <div className="education">

  <div className="cycle">
    <div className="content">
      <h3 className="gradient-text">EDUCATION</h3>

      <h5>
      Licence Diploma <br />
      Software Engineering and Information Systems
        <br />
        University of Science Gabes<br />
       
      </h5>
    </div>

    <div className="timeline">
      <img src="line.png" alt="timeline" />
    </div>

    <div className="dates">
      <h5>September 2023</h5>
      <h5>June 2026</h5>
    </div>
  </div>

  <div className="cycle">
    <div className="content">
      <h3 className="gradient-text">EXPERIENCE</h3>

      <h5>
        KIFAHI <br />
        Internship | BI Bot & Data Analysis
      </h5>
    </div>

    <div className="timeline">
      <img src="line.png" alt="timeline" />
    </div>

    <div className="dates">
      <h5>January 2026</h5>
      <h5>May 2026</h5>
    </div>
  </div>

</div>
       
       
       
       
       
      </div>
      
      
      <br /><br /><br /><br /><br /><br /><br />
      
         
          <h3 >CERTIFICATIONS</h3>
          <br />
          <div className="a3">
            <a href="/CertificateOfCompletion_Career Essentials in Generative AI by Microsoft and LinkedIn.pdf" target="_blank" rel="noopener noreferrer">
            <img className="pdf-thumbnail" src="cer1.png" alt="cer1" />  
          </a>
              
           <a href="/CertificateOfCompletion_Ethics in the Age of Generative AI.pdf" target="_blank" rel="noopener noreferrer">
           <img className="pdf-thumbnail" src="cer2.png" alt="cer2" />  
          </a>
              
            
                <a href="/CertificateOfCompletion_Everyday AI Concepts.pdf" target="_blank" rel="noopener noreferrer">
           <img className="pdf-thumbnail" src="cer3.png" alt="cer3" />  
          </a>
              
          
    
     
     
     
     
     
     
       
           
          </div>
          <div>
            <br />
            <div className="a3">
               <a href="/CertificateOfCompletion_What Is Generative AI.pdf" target="_blank" rel="noopener noreferrer">
          <img className="pdf-thumbnail" src="cer4.png" alt="cer4" ></img>
          </a>
                
              <a href="/CertificateOfCompletion_Your Top AI Questions Answered AI Literacy for Everyone.pdf" target="_blank" rel="noopener noreferrer">
            <img className="pdf-thumbnail" src="cer5.png" alt="cer5" ></img>
          </a>
             
              
            <a href="/GeneralIABasicsandNLP.pdf" target="_blank" rel="noopener noreferrer">
            <img className="pdf-thumbnail" src="cer6.png" alt="cer6"   ></img>
          </a>
             
               <a href="/ML.pdf" target="_blank" rel="noopener noreferrer" >
            <img className="pdf-thumbnail" src="cer7.png" alt="cer7" ></img>
          </a>
             
             
                
          
            </div>
          </div>
    
       
      
      
      
    </section>
  );
};

export default Portfolio;





